// src/utils/formatNumber.js

export const formatNumberToIndianLocale = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return value; // Return the original value if it's not a number

    return number.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
